<template>
  <v-row
    class="object-features align-center justify-center"
    no-gutters
  >
    <v-col
      v-if="enableCollapsing && index === 0"
      cols="12"
      class="pt-3"
    >
      <div class="collapse-line" />
    </v-col>
    <v-col
      :cols="enableCollapsing ? 10 : 12"
      :class="enableCollapsing ? 'py-2' : 'pt-3 pb-1'"
      @click="openCollapsed"
    >
      <h3>{{ featureGroupTitle }}</h3>
    </v-col>
    <v-col
      v-if="enableCollapsing"
      cols="2"
      class="feature-collapse-icon py-2"
      @click="openCollapsed"
    >
      <v-icon small>
        {{ collapsed ? 'fa-chevron-down' : 'fa-chevron-up' }}
      </v-icon>
    </v-col>
    <v-col
      v-if="!collapsed"
      :class="enableCollapsing ? 'pb-4 pt-2' : ''"
      cols="12"
    >
      <!-- OBJECT AREA SIZE INFO -->

      <v-container
        v-if="showAreaAndFloorInfo"
        class="pa-0"
      >
        <v-row dense>
          <v-col
            cols="1"
            class="text-right pr-1"
          />
          <v-col
            cols="1"
            class="text-center"
          >
            <v-icon small> fa-home </v-icon>
          </v-col>
          <v-col cols="10">
            {{ areaAndFloorInfo }}
          </v-col>
        </v-row>
      </v-container>

      <!-- MAX PERSON -->

      <v-container
        v-if="
          featureGroup &&
          featureGroup.groupName_en === 'House' &&
          object.maxPeople > 0
        "
        class="pa-0"
      >
        <v-row dense>
          <v-col
            cols="1"
            class="text-right pr-1"
          />
          <v-col
            cols="1"
            class="text-center"
          >
            <v-icon small> fa-users </v-icon>
          </v-col>
          <v-col cols="10">
            {{ capitalize($i18n.t('max')) }} {{ object.maxPeople }}
            {{ $i18n.t('inimest') }}
          </v-col>
        </v-row>
      </v-container>

      <!-- ROOMS -->

      <v-container
        v-if="featureGroup && featureGroup.groupName_en === 'House'"
        class="pa-0"
      >
        <v-row dense>
          <v-col
            cols="1"
            class="text-right pr-1"
          />
          <v-col
            cols="1"
            class="text-center"
          >
            <v-icon small> fa-bed </v-icon>
          </v-col>
          <v-col cols="10">
            {{ object.bedrooms }}
            {{
              object.bedrooms > 1
                ? $i18n.t('magamistoaga')
                : $i18n.t('magamistuba')
            }}
          </v-col>
          <v-col
            cols="1"
            class="text-right pr-1"
          />
          <v-col
            cols="1"
            class="text-center"
          >
            <v-icon small> fa-bath </v-icon>
          </v-col>
          <v-col cols="10">
            {{ object.bathrooms }}
            {{
              object.bathrooms > 1
                ? $i18n.t('vannitoaga')
                : $i18n.t('vannituba')
            }}
          </v-col>
        </v-row>
      </v-container>

      <!-- SELECTED FEATURES -->

      <v-container
        v-for="(feature, fIndex) in objectFeatures.filter((f) => {
          return (
            featuresList[f.id] &&
            featuresList[f.id].group &&
            featuresList[f.id].group['_id'] === featureGroup['_id']
          )
        })"
        :key="fIndex + '_'"
        class="pa-0"
      >
        <v-row
          v-if="featuresList[feature.id] && feature.checked === true"
          dense
        >
          <v-col
            cols="1"
            class="text-right pr-1"
          >
            <template v-if="feature.quantity">
              {{ feature.quantity }} x
            </template>
          </v-col>
          <v-col
            cols="1"
            class="text-center"
          >
            <v-icon small>
              {{ featuresList[feature.id].icon }}
            </v-icon>
          </v-col>
          <v-col cols="10">
            {{
              capitalize(featuresList[feature.id]['name_' + lang]) +
              (feature.distance ? ': ' + feature.distance : '')
            }}
            {{
              feature.extraInfo
                ? '(' +
                  (featuresList[feature.id].extraInfoTranslationCode
                    ? $i18n.t(
                        featuresList[feature.id].extraInfoTranslationCode
                      ) + ' '
                    : '') +
                  feature.extraInfo +
                  ')'
                : ''
            }}
          </v-col>
        </v-row>
      </v-container>
    </v-col>
    <v-col
      v-if="enableCollapsing"
      cols="12"
    >
      <div class="collapse-line" />
    </v-col>
  </v-row>
</template>

<script>
import sharedMethods from '../../methods/sharedMethods'
import { createHelpers } from 'vuex-map-fields'
import state from '../../store/state.js'

const { mapFields } = createHelpers({
  getterType: 'getField',
  mutationType: 'updateField',
})

export default {
  name: 'ObjectInfoFeaturesForGroup',

  data() {
    return {
      collapsed: false,
      enableCollapsing: false,
    }
  },

  props: {
    featureGroup: {
      type: Object,
      default: () => {
        return {}
      },
    },
    index: {
      type: Number,
      default: -1,
    },
    object: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },

  created() {
    if (this.mobile && this.featureGroup.id !== '5bc978b1e07c9e232eca5699') {
      // Requested to show now on mobile
      // this.collapsed = true
      // this.enableCollapsing = true
    }
  },

  computed: {
    ...mapFields(Object.keys(state)),

    featureGroupTitle() {
      return this.featureGroup?.groupName_en === 'House'
        ? this.capitalize(
            this.object?.exactType?.['typeName_' + this.lang] ||
              this.object.type?.['typeName_' + this.lang]
          )
        : this.featureGroup?.['groupName_' + this.lang]
    },

    showAreaAndFloorInfo() {
      return (
        this.featureGroup?.groupName_en === 'House' &&
        (this.object.squareMeters || this.object.floors)
      )
    },

    areaAndFloorInfo() {
      const infos = []
      if (this.object.squareMeters) {
        infos.push(this.object.squareMeters + ' m2')
      }

      if (this.object.onFloor) {
        infos.push(this.$i18n.t('floor') + ': ' + this.object.onFloor)
      }
      if (this.object.floors) {
        const title =
          this.object.floors === 1
            ? this.$i18n.t('floor')
            : this.$i18n.t('floors')
        infos.push(this.object.floors + ' ' + title)
      }

      return infos.join(', ')
    },

    objectFeatures() {
      if (!this.object.features) {
        return []
      }
      return Object.keys(this.object.features)
        .map((id) => {
          const feature = this.object.features[id]
          feature.id = id
          return feature
        })
        .sort((a, b) => {
          return this.featuresList[a.id]?.sortOrder >=
            this.featuresList[b.id]?.sortOrder
            ? 1
            : -1
        })
    },
  },

  methods: {
    ...sharedMethods,

    openCollapsed() {
      if (this.enableCollapsing) {
        this.collapsed = !this.collapsed
      }
    },
  },
}
</script>
